import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CustomProductsService } from 'src/app/modules/custom-landing/custom-products/custom-products.service';
import { TenderSelectProductsPlaceBidComponent } from '../tender-select-products-place-bid/tender-select-products-place-bid.component';
import { TenderPricingOptionComponent } from '../tender-pricing-option/tender-pricing-option.component';
import { TenderPlaceBidComponent } from 'src/app/shared/components/tender-place-bid/tender-place-bid.component';
import { NgIf, NgFor, NgClass, DecimalPipe, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { I18nModule } from '@spartacus/core';
@Component({
    selector: 'app-tender-select-products',
    templateUrl: './tender-select-products.component.html',
    styleUrls: ['./tender-select-products.component.scss'],
    imports: [NgIf, NgFor, NgClass, FormsModule, DecimalPipe, DatePipe, I18nModule]
})
export class TenderSelectProductsComponent implements OnInit {
  private modalRef: NgbModalRef;
  COI: boolean =false;
  OpenNegotiation:boolean=true;
  @Input() code:any;
  @Input() price:number;
  @Input() tabName: any;
  @Input() indexPrice:number;
  @Input() productsInfo: any;
  @Input() indexValue: any;
@Input() quantity:any;
@Input() quantityshw:any;
@Input() dischargePortshw:any;
@Input() indexDisabled:any;
@Input() fixedDisabled:any;
@Input() disabled:any
@Input() isQuantityUnrestricted:boolean;
productInfo:any=[];
tabValue: any;
  material1: boolean =true;
  public checkMaterial1:boolean;
  biddingTerms = '';
  requestParams: any;
  productValue:any;
  parameter=[];
  productSelect:any;
  checkboxError:boolean=false;
  constructor(public ActiveModal: NgbActiveModal,private customProductService: CustomProductsService,public ModalService:NgbModal,private modalService: NgbModal) { }

  ngOnInit(): void {
    this.indexValue = 0;
    console.log(this.productsInfo);
    this.productSelect=this.productsInfo && this.productsInfo.tenderEntries;
    this.productInfo=this.productsInfo && this.productsInfo.tenderEntries;
    this.productsInfo?.combinedTenders.map(val=>{
      if(val  && val.isRequired === undefined){
        val.checked = false
      }else if(val  && (val.isRequired === true || val.checked === true)){
        val.checked = true
        this.parameter.push(val);
      }else if(val  && (val.isRequired === false && val.checked === false)){
        val.checked = false
      }
      // if(val && this.parameter.length>1){
      //   val.checked = true
      // }
    })
   this.parameter=[...new Map(this.parameter.map(v => [v.entryNumber, v])).values()]
  }
  close(): any {
    this.productInfo.map(val=>{
        val.checked = false
    })
    this.ActiveModal.close();
    //this.productSelect[this.indexValue].pricingOptionsEnum[0].pricingOptions=''
  }
  onCheckboxChange(e,event) {
   
    let checked = event.target.checked;    
    if(checked){
    if (e) {      
     this.parameter.push(e);
    }else{   
      this.parameter.push();
    }
  }
  if(this.parameter.length>=1){
    this.checkboxError=false;
  }
  if(!checked){
    const index = this.parameter.findIndex(x => x.checked === false);
    this.parameter.splice(index, 1);    
  }
  }
  Openmodal(){
    this.parameter.sort(function(a, b) {
      return parseInt(a.entryNumber) - parseInt(b.entryNumber);
  });
  console.log(this.parameter,'ascending')
    if(this.parameter.length==0){
      this.checkboxError=true;
    }
if(this.parameter.length > 1){
  this.ActiveModal.close();
//   if(this.parameter[this.indexValue].pricingOptionsEnum.length>1){
//   const ModalRef = this.modalService.open(TenderSelectProductsPlaceBidComponent,{centered: true,size:'sm'});
//   ModalRef.componentInstance.code =this.productsInfo;
//   ModalRef.componentInstance.price = '0';
//   ModalRef.componentInstance.indexPrice = '0';
//   ModalRef.componentInstance.index =this.parameter;
//  ModalRef.componentInstance.indexValue = this.indexValue;
// this.productSelect[this.indexValue].pricingOptionsEnum[0].pricingOptions='';
// }
  const ModalRef = this.modalService.open(TenderSelectProductsPlaceBidComponent,{centered: true,size:'md'});
  ModalRef.componentInstance.code =this.productsInfo;
    ModalRef.componentInstance.indexDisabled=false;
    ModalRef.componentInstance.fixedDisabled=false;
    ModalRef.componentInstance.disabled=false;

  if(this.productsInfo.commodityType=='CN'){
    ModalRef.componentInstance.price = this.parameter[this.indexValue].relativePrice?this.parameter[this.indexValue].relativePrice:'';
    ModalRef.componentInstance.indexPrice =this.parameter[this.indexValue].premiumDiscount?this.parameter[this.indexValue].premiumDiscount:'';
  
  }
  this.parameter[this.indexValue].finalQPFromDate=this.parameter[this.indexValue].finalQPFromDate;
  this.parameter[this.indexValue].finalQPToDate=this.parameter[this.indexValue].finalQPToDate;
  // ModalRef.componentInstance.quantityshw = this.quantityshw;
  ModalRef.componentInstance.quantityshw = this.quantityshw;
  ModalRef.componentInstance.dischargePortshw = this.dischargePortshw;
  ModalRef.componentInstance.isQuantityUnrestricted = this.parameter[this.indexValue].isQuantityUnrestricted;
  console.log(this.productsInfo,'pricecheck')
  if(this.productsInfo.commodityType!='CN'){
    ModalRef.componentInstance.price = this.parameter[this.indexValue].materialFixedPrice1?this.parameter[this.indexValue].materialFixedPrice1:'';
    ModalRef.componentInstance.indexPrice = this.parameter[this.indexValue].materialIndexPrice1?this.parameter[this.indexValue].materialIndexPrice1:'';  
  }
  ModalRef.componentInstance.index =this.parameter;
 ModalRef.componentInstance.indexValue = this.indexValue;
 this.parameter[this.indexValue].priceTab=''
 if(this.parameter[this.indexValue].minimumQuantity && this.parameter[this.indexValue].maximumQuantity){
 ModalRef.componentInstance.quantity = this.parameter[this.indexValue].maximumQuantity;
 }
}
if(this.parameter.length == 1){  
  this.ActiveModal.close();
  if(this.productsInfo.commodityType=='CN'){
    const ModalRef = this.ModalService.open(TenderPlaceBidComponent,{centered: true,size:'md'});
    ModalRef.componentInstance.productsEntry = this.parameter;
    ModalRef.componentInstance.selectProduct = this.productsInfo;
    ModalRef.componentInstance.productsInfo = this.productsInfo;
    ModalRef.componentInstance.price = '';
    ModalRef.componentInstance.quantityshw = this.quantityshw ? this.quantityshw : this.parameter[0].quantityshw;;
    ModalRef.componentInstance.dischargePortshw = this.dischargePortshw ? this.dischargePortshw : this.parameter[0].dischargePortshw;;

    if(this.parameter[this.indexValue].minimumQuantity && this.parameter[this.indexValue].maximumQuantity){
      ModalRef.componentInstance.quantity = this.parameter[this.indexValue].maximumQuantity;
    }
  }
  if(this.parameter[this.indexValue].pricingOptionsEnum.length==1 && this.productsInfo.commodityType!='CN'){
    const ModalRef = this.ModalService.open(TenderPlaceBidComponent,{centered: true,size:'md'});
    ModalRef.componentInstance.productsEntry = this.parameter;
    ModalRef.componentInstance.selectProduct = this.productsInfo;
    ModalRef.componentInstance.productsInfo = this.productsInfo;      
    ModalRef.componentInstance.screen = 'placebid';
    ModalRef.componentInstance.lastScreen ='multiplematerial';
    ModalRef.componentInstance.quantityshw = this.parameter[0].quantityshw;
    ModalRef.componentInstance.tabName=this.parameter[0].pricingOptionsEnum[0].pricingOptions;
    ModalRef.componentInstance.dischargePortshw = this.dischargePortshw;
    if(this.parameter[this.indexValue].minimumQuantity && this.parameter[this.indexValue].maximumQuantity){
      ModalRef.componentInstance.quantity = this.parameter[this.indexValue].maximumQuantity;
    }
  }
  if(this.parameter[this.indexValue].pricingOptionsEnum.length>1 && this.productsInfo.commodityType!='CN'){
  const ModalRef = this.ModalService.open(TenderPlaceBidComponent,{centered: true,size:'md'});
  ModalRef.componentInstance.productsEntry = this.parameter;
  ModalRef.componentInstance.selectProduct = this.productsInfo;
  ModalRef.componentInstance.productsInfo = this.productsInfo;
  if(this.parameter[this.indexValue].minimumQuantity && this.parameter[this.indexValue].maximumQuantity){
    ModalRef.componentInstance.quantity = this.parameter[this.indexValue].maximumQuantity;
  }
  ModalRef.componentInstance.quantityshw = this.quantityshw ? this.quantityshw : this.parameter[0].quantityshw;
  ModalRef.componentInstance.dischargePortshw = this.dischargePortshw ? this.dischargePortshw : this.parameter[0].dischargePortshw;
}
}
  }
}
